export default "__VITE_ASSET__04b6ba91__"